import { defaultApiState } from '../api.state';

export const productState = {
  apiState: {
    getProducts: defaultApiState,
    getProduct: defaultApiState,
    deleteProduct: defaultApiState,
    addProduct: defaultApiState,
    updateProduct: defaultApiState,
  },
  products: [],
  product: undefined,
};
